import React, { Fragment, useRef } from 'react'


import ReactTooltip from 'react-tooltip'

import {
  bool, string, func, object, number, node, oneOfType,
} from 'prop-types'

import { EMPTY_OBJECT, NOOP } from 'Utils/stableDefaults'

function Tooltip({
  containerClass = '',
  className = '',
  id = '',
  href = '',
  onClick = NOOP,
  style = EMPTY_OBJECT,
  children,
  place = '',
  tooltipClassName = '',
  html = false,
  delayHide = 0,
  delayShow = 300,
  onShow = NOOP,
  content = '',
  heading = '',
  overridePosition = null,
  clickable = false,
  onHide = NOOP,
  isAdjustable = false,
  offset = EMPTY_OBJECT,
  delayUpdate = 0,
  globalEventOff = null,
  event = '',
  wrapperTag: WrapperTag = 'div',
}) {
  const baseID = `tooltip-${id}`
  const rebuildTimeoutRef = useRef(null)

  const handleAfterHide = () => {
    if (onHide) onHide()

    if (rebuildTimeoutRef.current) {
      clearTimeout(rebuildTimeoutRef.current)
    }

    rebuildTimeoutRef.current = setTimeout(() => {
      ReactTooltip.rebuild()
      rebuildTimeoutRef.current = null
    }, 100)
  }

  const tooltipContent = (
    <Fragment>
      {heading && <div className="cgt-tooltip__head">{heading}</div>}
      {content}
    </Fragment>
  )

  const spanProps = {
    className,
    'data-tip': true,
    'data-for': id,
    href,
    onClick,
    style,
    ...(event && { 'data-event': event, suppressHydrationWarning: true }),
  }

  return (
    <WrapperTag className={containerClass}>
      <WrapperTag {...spanProps}>
        {children}
      </WrapperTag>
      <ReactTooltip
        place={place}
        effect="solid"
        id={id}
        uuid={baseID}
        className={`
          cgt-tooltip ${tooltipClassName || ''}
          ${clickable ? 'cgt-tooltip--clickable' : ''}
          ${isAdjustable ? 'cgt-tooltip--adjustable' : ''}
        `.trim()}
        html={html}
        delayHide={clickable && !delayHide ? 500 : delayHide}
        delayShow={delayShow}
        delayUpdate={delayUpdate}
        afterShow={onShow}
        afterHide={handleAfterHide}
        globalEventOff={globalEventOff}
        overridePosition={overridePosition}
        offset={offset}
      >
        {html ? content : tooltipContent}
      </ReactTooltip>
    </WrapperTag>
  )
}

Tooltip.propTypes = {
  containerClass: string,
  className: string,
  id: string,
  href: string,
  onClick: func,
  onShow: func,
  style: object,
  place: string,
  tooltipClassName: string,
  html: bool,
  delayHide: number,
  delayShow: number,
  content: oneOfType([string, node]),
  heading: oneOfType([string, node]),
  overridePosition: func,
  clickable: bool,
  onHide: func,
  isAdjustable: bool,
  offset: object,
  delayUpdate: number,
  globalEventOff: string,
  event: string,
  wrapperTag: string,
}

export default Tooltip
